// extracted by mini-css-extract-plugin
export default {"download":"Download_download__Tt6qp","downloadBtn":"Download_downloadBtn__28vqQ"};